module.exports = __webpack_public_path__ + "img/20180815_150119_044.db2a51d6.jpg";